package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.img
import games.polyclub.frontend.lib.react.utils.useEffectAsync
import games.polyclub.frontend.lib.utils.delete
import games.polyclub.website.frontend.store.appScope
import js.core.Object
import react.dom.html.ImgHTMLAttributes
import react.useState
import web.html.HTMLImageElement

external interface AsyncImgProps : ImgHTMLAttributes<HTMLImageElement> {
    var srcLoading: String?
    var srcLoader: (suspend () -> String)?
}

val AsyncImg = SFC<AsyncImgProps> { props ->
    val (loadedUrl, setLoadedUrl) = useState(props.src ?: props.srcLoading)
    appScope.useEffectAsync(props.srcLoader) {
        props.srcLoader?.let { asyncUrl ->
            setLoadedUrl(asyncUrl())
        }
    }

    img {
        Object.assign(this, props)
        delete(this, "srcLoader")
        delete(this, "srcLoading")
        src = loadedUrl ?: "/img/loading-bigger.svg"
        +props.children
    }
}
